import React, { useState } from "react";
import Navbar from './Navbar'
import Footer from './Footer'
// import MapFromSheet from "./MapFromSheet";
import Whatsapp from "./Whatsapp";
import DirectorGrid from "./DirectorGrid";

const TABS = [
  {
    id: 'social',
    label: 'Social',
    content: (
      <>
        <p className="text-light">Connect with fellow alumni through reunions, cultural events, and social gatherings across North America.</p>
        <ul className="list-item text-light">
          <li>Annual meetups and regional chapter events</li>
          <li>Cultural celebrations and festival gatherings</li>
          <li>Alumni networking dinners and mixers</li>
          <li>Community service and volunteer initiatives</li>
        </ul>
      </>
    ),
  },
  {
    id: 'professional',
    label: 'Professional',
    content: (
      <>
        <p className="text-light">Advance your career and support fellow alumni through mentorship and professional development.</p>
        <ul className="list-item text-light">
          <li>Career mentorship and job referral network</li>
          <li>Industry talks and leadership workshops</li>
          <li>Internship opportunities for current students</li>
          <li>Professional networking events</li>
        </ul>
      </>
    ),
  },
  {
    id: 'intellectual',
    label: 'Intellectual',
    content: (
      <>
        <p className="text-light">Stay engaged with academic excellence and knowledge sharing within our alumni community.</p>
        <ul className="list-item text-light">
          <li>Scholarship programs for deserving students</li>
          <li>Guest lectures and technical seminars</li>
          <li>Research collaboration opportunities</li>
          <li>Support for university academic initiatives</li>
        </ul>
      </>
    ),
  },
];

export default function About() {
  const [activeTab, setActiveTab] = useState('social');

  return (
    <div className="main-wrapper page page-about">
      <Navbar />

      <div className="content-wrapper">
        <div className="about-us" data-aos="fade-up">
          <div className="about-us-title text-center" data-aos="fade-up">
            <div className="container">
              <h1 className="heading-bold text-uppercase">About Us</h1>
              <p className="page-hero-subtitle">
                LIT Alumni Association North America — our story, mission, and leadership
              </p>
            </div>
          </div>
          <div className="about-us-content">
            <div className="container">
              <div className="about-content-inner" data-aos="fade-up">
                <p className="text-light">
                  LIT Alumni Association North America [LITAANA] is the North American Chapter of the LIT Alumni Association [LITAA]. LIT University [Formerly Laxminarayan Institute of Technology] is a public state university of the Government of Maharashtra situated at Nagpur, Maharashtra, India. It was established in 1942 and is one of the oldest and the most premier engineering colleges for Chemical Engineering and Technology in India.
                </p>
                <p className="text-light">
                  LIT Alumni Association (formerly LIT Old Students Association - LITOSA) is an independent body of the alumni of LIT University [Formerly Laxminarayan Institute of Technology], Nagpur, Maharashtra, India and is duly registered under the provisions of Societies Registration Act, 1860 and Maharashtra Public Trust Act 1950 of the Government of India. The Registered office of the LIT Alumni Association is located in Nagpur in the premises of the LIT University, Nagpur , Maharashtra, India. The different regional chapters function under the parent body for easier integration of the geographically dispersed alumni. LITAANA is one such regional chapter for the LITAA members who are based in the North Americas.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* New content from LITAA_NA_Website_Content.docx */}
        <section className="litaana-content-section" data-aos="fade-up">
          <div className="container">
            <h2>Who We Are</h2>
            <p className="text-light">
              The LIT Alumni Association North America Chapter (LITAA NA) is the official North American chapter of the LIT Alumni Association (LITAA) — the independent alumni body of Laxminarayan Innovation Technological University (LITU), Nagpur, India.
            </p>
            <p className="text-light">
              Incorporated in May 2025 as a 501(c)(3) nonprofit organization in the State of Texas, LITAA NA represents LIT University alumni living and working across the United States and Canada. We are a chapter of a global alumni community of over 6,000 members — professionals in chemical engineering, technology, energy, manufacturing, research, and beyond — and we carry the values and mission of our alma mater to North America.
            </p>

            <h3>Our Mission</h3>
            <p className="text-light">
              To connect, engage, and empower LIT University alumni across North America — and through our collective strength, make a meaningful and lasting contribution to our alma mater and the generations of students who will follow us.
            </p>

            <h3>Our Story — The Legacy We Carry</h3>
            <p className="text-light">
              Laxminarayan Innovation Technological University traces its origins to a remarkable act of generosity. Rao Bahadur Laxminarayan, a mine owner who had risen from modest origins to great success, was deeply troubled by India&apos;s dependence on foreign technology. When he passed in 1930, he bequeathed his entire wealth and hundreds of acres of land to what is now Rashtrasant Tukadoji Maharaj Nagpur University, with a single request: establish an institute for applied sciences in the mining and chemical industries.
            </p>
            <p className="text-light">
              That bequest became LIT — the Laxminarayan Institute of Technology — founded in 1942, an institution that has since produced generations of chemical engineers and technologists who have gone on to lead industries across India and the world. Today, as Laxminarayan Innovation Technological University (LITU), it holds NAAC A+ accreditation, operates across a 78-acre campus in Nagpur, and continues to train the next generation of engineers in chemical engineering, food technology, petroleum refining, polymer technology, surface coating, paint technology, biotechnology, and more.
            </p>
            <p className="text-light">
              We, the alumni of LIT in North America, are part of that story. And through this chapter, we intend to give back to it.
            </p>

            <h3>Our Purpose And Objectives</h3>
            <p className="text-light">
              Laxminarayan Innovation Technological University (LITU) is a premier chemical engineering and technology institution located in Nagpur, in the heart of central India. With a legacy of excellence in education and research, LITU has produced generations of distinguished chemical engineers and technologists contributing across industries and academia worldwide.
            </p>
            <p className="text-light">
              The LITU Alumni Association is a vibrant network of graduates who remain actively engaged with the institute and with one another. Notably, the association includes a strong and growing chapter in North America, with over 150 alumni currently based across the United States and Canada.
            </p>
            <ol className="objectives-list text-light">
              <li><strong>Strengthen Alumni–Institute Connections</strong> — Establish a structured community for LITU alumni in North America to connect with each other and with the institute, fostering consistent engagement and shared identity.</li>
              <li><strong>Support Education through Scholarships And Awards</strong> — Provide funding, scholarships, or awards to students or faculty at LITU, recognizing academic excellence and leadership.</li>
              <li><strong>Mentorship, Career Support And Professional Development</strong> — Mentor current students and recent graduates, offer career guidance, internships, and industry insights as well as support job placement and professional transition help especially for grad students and early-career members.</li>
              <li><strong>Facilitate Institutional Advancement And Resource Mobilization</strong> — Mobilize alumni expertise, volunteering, and resources (financial or in-kind) to support academic growth. Raise funds to support select academic and infrastructure projects.</li>
              <li><strong>Elevate LITU&apos;s Brand, Reputation And Collaboration</strong> — Serve as ambassadors in North America to promote LITU&apos;s academic reputation, research collaborations, and partnerships—for LITU&apos;s brand-building in the educational and corporate ecosystem in North America.</li>
            </ol>

            <h3>About LITAA — The Global Alumni Body</h3>
            <p className="text-light">
              The LIT Alumni Association (LITAA), formerly the LIT Old Students Association (LITOSA), is the registered independent alumni association of LIT University. With over 6,000 members worldwide — high-achieving professionals in chemical engineering and related fields — LITAA has been a driving force in supporting the university&apos;s development, advocating for its institutional growth, and connecting alumni across the globe.
            </p>
            <p className="text-light">
              LITAA chapters exist across India and internationally, each contributing to the broader mission of alumni engagement, institutional support, and community building. The North America Chapter, established in 2025, is the newest and most formally structured of the international chapters — a 501(c)(3) nonprofit with its own board of directors, governed independently while remaining aligned with LITAA&apos;s global mission.
            </p>

            <h3>Our Board of Directors</h3>
            <DirectorGrid showRoles />
            <p className="text-light">
              Additional leadership and committee details will be published as the chapter grows. If you are interested in volunteering or serving on a committee, we welcome your involvement — please reach out through the Contact page.
            </p>

            <h3>Legal &amp; Organizational Information</h3>
            <dl className="litaana-legal-info">
              <dt>Legal Name</dt>
              <dd>LIT Alumni Association North America Chapter</dd>
              <dt>Organization Type</dt>
              <dd>Domestic Nonprofit Corporation</dd>
              <dt>State of Incorporation</dt>
              <dd>Texas, USA</dd>
              <dt>Date of Incorporation</dt>
              <dd>May 8, 2025</dd>
              <dt>EIN</dt>
              <dd>39-2341136</dd>
              <dt>IRS Status</dt>
              <dd>501(c)(3) tax-exempt organization — donations are tax-deductible to the extent permitted by law</dd>
              <dt>Registered Office</dt>
              <dd>11104 W Airport Blvd Ste 213, Stafford, TX 77477</dd>
              <dt>Affiliated with</dt>
              <dd>LIT Alumni Association (LITAA) — <a href="https://www.litalumni.org" target="_blank" rel="noopener noreferrer">www.litalumni.org</a></dd>
            </dl>
          </div>
        </section>

        <div className="programs-services" data-aos="fade-up">
          <div className="container">
            <div className="row">
              <div className="services-img col-md-6 col-sm-12" data-aos="zoom-in-right">
                <img className="img-responsive" src="images/LIT Nagpur sRGB.webp" alt="LIT University campus, Nagpur" />
              </div>
              <div className="services-content col-md-6 col-sm-12" data-aos="zoom-in-left">
                <h2 className="heading-regular">Programs &amp; Services</h2>
                <div id="tab_services">
                  <ul className="nav nav-tabs litaana-tabs" role="tablist">
                    {TABS.map((tab) => (
                      <li
                        key={tab.id}
                        role="presentation"
                        className={activeTab === tab.id ? 'active' : ''}
                      >
                        <button
                          type="button"
                          role="tab"
                          className="litaana-tab-btn"
                          aria-selected={activeTab === tab.id}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                  <div className="tab-content">
                    {TABS.map((tab) => (
                      <div
                        key={tab.id}
                        role="tabpanel"
                        className={`tab-pane ${activeTab === tab.id ? 'active' : ''}`}
                        id={tab.id}
                      >
                        <div className="tab-content-wrapper">
                          {tab.content}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="our-history" data-aos="fade-up">
          <div className="container">
            <div className="title-page text-center" data-aos="zoom-in">
              <h2 className="text-regular">Our History</h2>
              <p className="text-light">Milestones in the LITAANA journey</p>
            </div>
            <div className="history-content">
              <ul className="list-history text-center" data-aos="fade-up">
                <li><span className="history-title">Alma Mater LIT Nagpur was established</span><span className="history-dot"><span /></span><span className="history-year">1942</span></li>
                <li><span className="history-title">LIT Alumni Association was constituted</span><span className="history-dot"><span /></span><span className="history-year">2016</span></li>
                <li><span className="history-title">LITAANA was instituted as a legal entity</span><span className="history-dot"><span /></span><span className="history-year">2025</span></li>

              </ul>
            </div>
          </div>
        </div>

        <div id="contacts" className="map" data-aos="fade-up">
          <div className="container">
            <div className="title-page text-center" data-aos="zoom-in">
              <h2 className="text-regular">We are not just Friends, We are Family</h2>
              <p className="text-light">Connect with alumni across North America</p>
            </div>
            <div className="map-content" data-aos="zoom-in">
              {/* Old map: Leaflet + OpenStreetMap city markers from Google Sheet
              <MapFromSheet />
              */}
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.1675834200714!2d79.04624707503481!3d21.145728080532994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c0419d1b4733%3A0x7e43e9e0b53fe974!2sLaxminarayan%20Innovation%20Technological%20University!5e0!3m2!1sen!2sde!4v1783500722043!5m2!1sen!2sde"
                width="100%"
                height={450}
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                title="Laxminarayan Innovation Technological University, Nagpur"
              />
            </div>
          </div>
        </div>

        <Whatsapp />
      </div>

      <Footer />
    </div>
  );
}
